import { api } from './axios';

export type FileCategory =
  | 'student-photos'
  | 'staff-photos'
  | 'asset-photos'
  | 'staff-documents'
  | 'expense-receipts';

export interface UploadResult {
  path: string;
  url: string;
  category: FileCategory;
  size: number;
  contentType: string;
}

export const filesApi = {
  upload: (file: File, category: FileCategory): Promise<UploadResult> => {
    const form = new FormData();
    form.append('category', category);
    form.append('file', file);
    return api
      .post<UploadResult>('/files/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
};
